import { useEffect, useRef, useMemo, lazy, useState, Suspense } from 'react';
import { Tabela, TabelaCabeca, TabelaCorpo, CorpoTable, Tabler } from "../../../../../components/formulario/tableStyled"
import { UseList } from "../../context/getEvents";
import LoadingGif from '../../../../../components/loading';

const Rows = lazy(() => import('../rows'))

export default function TabelaListaEventos() {

  const [filas, setFilas] = useState({ fila: 0, tamanho: 300 });

  const { listAll, nextPagina, pagina } = UseList()

  const devRef = useRef<HTMLDivElement>(null);

  useMemo(() => {
    listAll?.slice(0, ((pagina + 1) * 30))
  }, [pagina]);


  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])


  return (
    <>
      <Tabler>
        <CorpoTable ref={devRef}>
          <Tabela>
            <>
              <TabelaCabeca>
                <tr>
                  <th>Sede</th>
                  <th>Ministério</th>
                  <th>Evento</th>
                  <th>Cidade</th>
                  <th>Início</th>
                  <th>Término</th>
                  <th>Ativo</th>
                  <th>Inscrição?</th>
                  <th>Detalhes</th>
                </tr>
              </TabelaCabeca>
              <TabelaCorpo >
                <Suspense fallback={<LoadingGif/>}>
                  <Rows filas={filas} />
                </Suspense>
              </TabelaCorpo>
            </>
          </Tabela>
        </CorpoTable>
      </Tabler>
    </>
  )
}
